<template>
  <vx-card>
    <vs-table pagination :max-items="12" search :data="borrowersGroup">
      <template slot="header" vs-justify="flex-end">
        <div class="flex-1">
          {{ 'รายการทั้งหมด ' + borrowersGroup.length }}
        </div>
        <a :href="`${reportServer}/excel/dashboardProsecutionBorrowers`" target="_blank">
          <vs-button line-origin="left" color="success">ดาวน์โหลดไฟล์ Excel</vs-button>
        </a>
      </template>
      <template slot="thead">
        <vs-th>เลขที่บัตรประชาชน</vs-th>
        <vs-th>ชื่อ-นามสกุล</vs-th>
        <vs-th>เลขที่สัญญา</vs-th>
        <vs-th>สถานะการศึกษา (มหาวิทยาลัย)</vs-th>
        <vs-th>วันที่ค้างชำระ</vs-th>
        <vs-th>จำนวนวันค้างชำระ</vs-th>
        <!--        <vs-th>จำนวนสัญญา</vs-th>-->
        <vs-th>สถานะการดำเนินคดี</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(row) in data" :key="row.id">
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{
                row.idCardNumber
              }}
            </router-link>
          </vs-td>
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{
                row.fullName
              }}
            </router-link>
          </vs-td>
          <vs-td>
            <router-link :to="{ name: 'accounting-contract-detail', params: {id: row.contractId}}">{{
                row.contractNo
              }}
            </router-link>
          </vs-td>
          <vs-td>
            {{ row.educationStatusName }}
          </vs-td>
          <vs-td>
            {{ row.agingDate }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.agingNumber }}
          </vs-td>
          <!--          <vs-td class="text-right">-->
          <!--            {{ row.contractCount  }}-->
          <!--          </vs-td>-->
          <vs-td vs-justify="flex-end">
            <vs-chip :color="row.caseStatus | caseStatusColor" class="product-order-status flex-1">{{
                row.caseStatusName
              }}
            </vs-chip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions: mapDashboardActions, mapState: mapDashboardState} = createNamespacedHelpers('Dashboard');
export default {
  name: 'DashboardProsecutionBorrowers',
  data() {
    return {
      reportServer: process.env.VUE_APP_REPORT_SERVER
    }
  },
  computed: {
    ...mapDashboardState(['dashboardProsecutionBorrowers']),
    borrowersGroup() {
      // return this.dashboardProsecutionBorrowers
      // group by idCardNumber
      return this.dashboardProsecutionBorrowers;
      // return this.dashboardProsecutionBorrowers.reduce((acc, item) => {
      //   const found = acc.find(i => i.idCardNumber === item.idCardNumber);
      //   if (found) {
      //     found.contractCount += 1;
      //   } else {
      //     acc.push({
      //       ...item,
      //       contractCount: 1,
      //     });
      //   }
      //   return acc;
      // }, []);
    },
    borrowers() {
      return this.dashboardProsecutionBorrowers;
    },
  },
  methods: {
    ...mapDashboardActions(['getDashboardProsecutionBorrowers']),
  },
  async created() {
    this.$vs.loading()
    await this.getDashboardProsecutionBorrowers();
    setTimeout(() => {
      this.$vs.loading.close()
    }, 150)
  },
}
</script>

<style scoped>
</style>

